(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ds-totebag-why"] && !Shopify.designMode) return;
  try {
    
  // Geschenk-Button (Handy): zur Mengen-Auswahl der PDP scrollen.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ds-tbw-jump]');
    if (!btn) return;
    var target = document.querySelector('[data-ds-bag-qty-heading]') || document.querySelector('variant-picker');
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
